import { render, staticRenderFns } from "./leftAndRightCard.vue?vue&type=template&id=7a195b73&scoped=true&"
import script from "./leftAndRightCard.vue?vue&type=script&lang=js&"
export * from "./leftAndRightCard.vue?vue&type=script&lang=js&"
import style0 from "./leftAndRightCard.vue?vue&type=style&index=0&id=7a195b73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a195b73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a195b73')) {
      api.createRecord('7a195b73', component.options)
    } else {
      api.reload('7a195b73', component.options)
    }
    module.hot.accept("./leftAndRightCard.vue?vue&type=template&id=7a195b73&scoped=true&", function () {
      api.rerender('7a195b73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/card/leftAndRightCard.vue"
export default component.exports